export default __webpack_public_path__ + "static/media/holdingPhone.ae1947cd.svg";